/* eslint-disable @typescript-eslint/no-unused-vars */
import { OrderType } from '../orders/types'
import storeInfo from '../store'

export const getOrder = () => (): OrderType => {
  const { order } = storeInfo.store.getState()
  return order
}
